export default __webpack_public_path__ + "static/media/sealofchaos.3d4e72a7.png";